package com.evoapps.evoshift.ui.documents

import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

/*
 * SH-122: how the documents screens write moments and sizes (also used by the UI tests' robots
 * to find the same text).
 */

/** "15.10.2026 12:00" in [zone] (the device's by default). */
fun formatMoment(instant: Instant, zone: TimeZone = TimeZone.currentSystemDefault()): String {
    val t = instant.toLocalDateTime(zone)
    fun two(n: Int) = n.toString().padStart(2, '0')
    return "${two(t.day)}.${two(t.month.number)}.${t.year} ${two(t.hour)}:${two(t.minute)}"
}

/** "820 KB", "2.4 MB". */
fun formatSize(bytes: Long): String = when {
    bytes < 1024 * 1024 -> "${(bytes + 1023) / 1024} KB"
    else -> {
        val tenths = (bytes * 10 + 512 * 1024) / (1024 * 1024)
        "${tenths / 10}.${tenths % 10} MB"
    }
}
